var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.children),function(child){return _c('div',{key:child.id,staticClass:"node-type-lb"},[_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.selectedLabel),expression:"selectedLabel"}],attrs:{"type":"radio"},domProps:{"value":child.id,"checked":_vm._q(_vm.selectedLabel,child.id)},on:{"change":function($event){_vm.selectedLabel=child.id}}},'input',{
                id   : child.id + '_radioButton',
                name : _vm.node.id + '_radioGroup',
            },false)),_c('label',_vm._b({},'label',{
                id  : child.id + '_label',
                for : child.id + '_radioButton'
            },false),[_vm._v(" "+_vm._s(child.layout.caption)+" ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }